import React from 'react';
import Icon from '../../../components/AppIcon';

const InterestsStep = ({ selectedInterests, onToggle }) => {
  const interests = [
    {
      id: 'events',
      title: 'Etkinlikler',
      icon: 'Calendar',
      description: 'Grup turları ve SUP etkinliklerine katılmak istiyorum',
      color: 'var(--color-primary)'
    },
    {
      id: 'marketplace',
      title: 'Alışveriş',
      icon: 'ShoppingBag',
      description: 'SUP ekipmanları almak veya satmak istiyorum',
      color: 'var(--color-secondary)'
    },
    {
      id: 'spots',
      title: 'Spot Keşfi',
      icon: 'MapPin',
      description: 'Yeni paddle noktaları keşfetmek istiyorum',
      color: 'var(--color-accent)'
    },
    {
      id: 'community',
      title: 'Topluluk',
      icon: 'Users',
      description: 'Diğer paddlerlarla tanışmak ve paylaşımda bulunmak istiyorum',
      color: 'var(--color-success)'
    },
    {
      id: 'carpool',
      title: 'Araç Paylaşımı',
      icon: 'Car',
      description: 'Etkinliklere birlikte gitmek için araç paylaşımı yapmak istiyorum',
      color: 'var(--color-warning)'
    },
    {
      id: 'blog',
      title: 'Blog & İpuçları',
      icon: 'BookOpen',
      description: 'SUP teknikleri ve ipuçları hakkında bilgi almak istiyorum',
      color: 'var(--color-primary)'
    }
  ];

  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
      <div className="text-center mb-8 md:mb-10 lg:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-3 md:mb-4">
          İlgi Alanlarınız
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
          Platformda en çok ilgilendiğiniz alanları seçin. Size özel içerikler önereceğiz
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6">
        {interests?.map((interest) => {
          const isSelected = selectedInterests?.includes(interest?.id);
          
          return (
            <button
              key={interest?.id}
              onClick={() => onToggle(interest?.id)}
              className={`p-6 md:p-7 lg:p-8 rounded-xl md:rounded-2xl border-2 transition-smooth text-left ${
                isSelected
                  ? 'border-[var(--color-primary)] bg-[rgba(27,75,102,0.08)] shadow-organic-lg'
                  : 'border-[var(--color-border)] bg-[var(--color-card)] hover:border-[var(--color-primary)] hover:shadow-organic'
              }`}
            >
              <div className="flex items-start gap-4 mb-4 md:mb-5">
                <div
                  className={`w-14 h-14 md:w-16 md:h-16 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0 ${
                    isSelected
                      ? 'bg-[var(--color-primary)] text-[var(--color-primary-foreground)]'
                      : 'bg-[var(--color-muted)] text-[var(--color-muted-foreground)]'
                  }`}
                >
                  <Icon name={interest?.icon} size={28} />
                </div>
                {isSelected && (
                  <Icon name="CheckCircle2" size={24} className="text-[var(--color-primary)] flex-shrink-0" />
                )}
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-[var(--color-foreground)] mb-2 md:mb-3">
                {interest?.title}
              </h3>
              <p className="text-sm md:text-base text-[var(--color-muted-foreground)] leading-relaxed">
                {interest?.description}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default InterestsStep;